import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_GROUPS, PATH_MY_PROFILE, PATH_REPORTS } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={user?.role !== 'runner' ? PATH_REPORTS.groupPerformance : PATH_GROUPS.root} />;
  }

  return <>{children}</>;
}
